{
  "title": "Guides",
  "subtitle": "Step-by-step work guides for the Uachieve team",
  "updated": "Updated {{date}}",
  "contents": "Contents",
  "pdf": {
    "ar": "Download PDF (Arabic)",
    "en": "Download PDF (English)"
  },
  "backToTop": "Back to top",
  "notFound": "Guide not found",
  "table": "Table (scrolls horizontally)"
}
